<template>
  <div class="math-config">
    <a-table
      :class="['table']"
      :columns="columns"
      :data-source="rows"
      :pagination="false"
      size="middle"
    >
      <template slot="value" slot-scope="currentValue, { valueField }">
        <a-input-number
          :value="currentValue"
          style="width: 100%"
          @change="setValue(valueField, $event)"
        />
      </template>
      <template slot="mandatory" slot-scope="currentValue, { mandatoryField }">
        <a-radio
          :checked="Boolean(currentValue)"
          @change="setValue(mandatoryField, $event.target.checked)"
        />
      </template>
      <template slot="warning" slot-scope="currentValue, { mandatoryField }">
        <a-radio
          :checked="Boolean(!currentValue)"
          @change="setValue(mandatoryField, !$event.target.checked)"
        />
      </template>
    </a-table>
  </div>
</template>

<script>
const params = Object.freeze([
  {
    type: 'Отсечение ошибочных цен',
    typeRowspan: 2,
    name: 'Верхняя граница',
    valueField: 'c1_high_limit',
    unit: '*99%',
    mandatoryField: 'c1_high_mandatory',
  },
  {
    name: 'Нижняя граница',
    valueField: 'c1_low_limit',
    unit: '*1%',
    mandatoryField: 'c1_low_mandatory',
  },
  {
    type: 'Отсечение по уровням цен',
    typeRowspan: 2,
    name: 'Верхняя граница',
    prefix: 'Средняя цена +',
    valueField: 'c2_high_limit',
    unit: '*σ',
    mandatoryField: 'c2_high_mandatory',
  },
  {
    name: 'Нижняя граница',
    prefix: 'Средняя цена -',
    valueField: 'c2_low_limit',
    unit: '*σ',
    mandatoryField: 'c2_low_mandatory',
  },
  {
    type: 'Контроль пределов цен',
    typeRowspan: 2,
    name: 'Верхняя граница',
    valueField: 'c3_high_limit',
    unit: '₽ (руб.)',
    mandatoryField: 'c3_high_mandatory',
  },
  {
    name: 'Нижняя граница',
    valueField: 'c3_low_limit',
    unit: '₽ (руб.)',
    mandatoryField: 'c3_low_mandatory',
  },
  {
    type: 'Параметры мат. обработки',
    typeRowspan: 5,
    name: 'Коэффициент M',
    valueField: 'coefficient_m',
    mandatoryField: 'coefficient_m_mandatory',
  },
  {
    name: 'Коэффициент M (Торговля)',
    valueField: 'coefficient_m_trade',
    mandatoryField: 'coefficient_m_trade_mandatory',
  },
  {
    name: 'Контроль регулярного наличия',
    valueField: 'regular_availability_check',
    mandatoryField: 'regular_availability_check_mandatory',
  },
  {
    name: 'Оценка достаточности',
    valueField: 'sufficiency_assessment',
    mandatoryField: 'sufficiency_assessment_mandatory',
  },
  {
    name: 'Доля резерва',
    valueField: 'reserve_part',
    unit: '%',
    mandatoryField: 'reserve_part_mandatory',
  },
]);

const columns = Object.freeze([
  {
    title: 'Тип',
    dataIndex: 'type',
    key: 'type',
    customRender: (value, row) => {
      return {
        children: value,
        attrs: {
          rowSpan: row.typeRowspan || 0,
        },
      };
    },
  },
  {
    title: 'Параметры',
    dataIndex: 'name',
    key: 'name',
    className: ['no-border'],
  },
  {
    dataIndex: 'prefix',
    key: 'prefix',
    className: ['no-border', 'align-right'],
  },
  {
    dataIndex: 'value',
    key: 'value',
    className: ['no-border', 'slim'],
    scopedSlots: {
      customRender: 'value',
    },
  },
  {
    dataIndex: 'unit',
    key: 'unit',
  },
  {
    title: 'Обязательный',
    dataIndex: 'mandatory',
    key: 'mandatory',
    scopedSlots: {
      customRender: 'mandatory',
    },
  },
  {
    title: 'Предупредительный',
    dataIndex: 'mandatory',
    key: 'warning',
    scopedSlots: {
      customRender: 'warning',
    },
  },
]);

export default {
  name: 'MathProcessingConfig',

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    columns,
  }),

  computed: {
    rows() {
      return params.map((item) => ({
        ...item,
        key: item.valueField,
        value: this.value[item.valueField],
        mandatory: this.value[item.mandatoryField],
      }));
    },
  },

  methods: {
    setValue(key, value) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },
  },
};
</script>

<style lang="scss">
.math-config {
  .ant-table-tbody {
    & > tr.ant-table-row-level-0:hover {
      & > td {
        background: unset;
      }
    }
  }

  .no-border {
    border-right: 0;
  }

  .align-right {
    text-align: right;
  }

  .slim {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  // TODO make more beautiful color alternation (depending on rowspan)
  .ant-table-tbody {
    & > tr:nth-child(4n + 3),
    & > tr:nth-child(4n + 4) {
      background-color: #f6faff !important;
    }

    & > tr:nth-child(4n + 1),
    & > tr:nth-child(4n + 2) {
      background-color: transparent !important;
    }
  }
}
</style>
